import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 18,
	viewBox: "0 0 10 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.29688 17.5947C9.21875 17.6729 9.10156 17.7119 8.98438 17.7119C8.82812 17.7119 8.75 17.6729 8.67188 17.5947L0.390625 9.31348C0.3125 9.23535 0.273438 9.15723 0.273438 9.00098C0.273438 8.88379 0.3125 8.7666 0.390625 8.68848L8.67188 0.407227C8.75 0.329102 8.82812 0.290039 8.98438 0.290039C9.10156 0.290039 9.21875 0.329102 9.29688 0.407227L9.60938 0.719727C9.6875 0.797852 9.72656 0.915039 9.72656 1.03223C9.72656 1.18848 9.6875 1.30566 9.60938 1.38379L1.95312 9.00098L9.60938 16.6182C9.6875 16.7354 9.72656 16.8525 9.72656 16.9697C9.72656 17.126 9.6875 17.2041 9.60938 17.2822L9.29688 17.5947Z",
		fill: "currentColor"
	})
});
export default SvgChevronLeft;
